<dff-side [observable]="vm$"> </dff-side>
